import { Maybe } from 'generated/graphql';
import { FC } from 'react';
import EquailityAndDiversityContainer from './EquailityAndDiversityContainer/EquailityAndDiversityContainer';

interface IEquailityAndDiversityContent {
  stageCandidateId: number;
  companyLogoUrl?: Maybe<string>;
  onEqualityStatementButtonClick: () => void;
  onCloseModal: () => void;
}

const EquailityAndDiversityContent: FC<IEquailityAndDiversityContent> = ({
  stageCandidateId,
  companyLogoUrl,
  onEqualityStatementButtonClick,
}) => {
  return (
    <EquailityAndDiversityContainer
      stageCandidateId={stageCandidateId}
      companyLogoUrl={companyLogoUrl}
      onEqualityStatementButtonClick={onEqualityStatementButtonClick}
    />
  );
};

export default EquailityAndDiversityContent;
